

  <div class="card card-with-sub-title">
    <div class="card-with-sub-title__header">
      <h5 class="title">Chat Volume</h5>
    </div>
    <div class="card-with-sub-title__content">
      <div class="graph-wrap">
        <base-highchart [configuration]="config" style="width: 100%; height: 150px; display: block">
        </base-highchart>
      </div>
    </div>
  </div>
  